export class NotReady extends Error {
  constructor() {
    super(`This call requires authorization and endpoint`);

    Object.setPrototypeOf(this, NotReady.prototype);
    Error.captureStackTrace(this, this.constructor);
  }
}
